var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.536,
    height: 25.536,
    viewBox: "0 0 25.536 25.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Question_Mark",
    "data-name": "Question Mark",
    transform: "translate(-7.266 -7.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    "data-name": "Path 9523",
    d: "M20.033,32.8A12.768,12.768,0,1,1,32.8,20.033,12.768,12.768,0,0,1,20.033,32.8Zm0-23.987a11.219,11.219,0,1,0,11.22,11.22,11.219,11.219,0,0,0-11.22-11.22Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M27.746,32.42a1.04,1.04,0,0,1-1.032-1.032.889.889,0,0,1,.021-.2.848.848,0,0,1,.057-.2,1.2,1.2,0,0,1,.1-.176,1.122,1.122,0,0,1,.284-.283.82.82,0,0,1,.176-.1.907.907,0,0,1,.2-.057,1.029,1.029,0,0,1,.929.284.732.732,0,0,1,.129.155,1.2,1.2,0,0,1,.1.176.848.848,0,0,1,.057.2.889.889,0,0,1,.021.2,1.04,1.04,0,0,1-1.032,1.032Zm-3.768-9.88a.774.774,0,0,1-.706-1.084,4.691,4.691,0,0,1,4.475-2.426.774.774,0,1,1,0,1.549,3.211,3.211,0,0,0-3.063,1.515.782.782,0,0,1-.706.447Z",
    transform: "translate(-7.712 -5.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M31.274,29.287a.774.774,0,0,1-.774-.774v-.977c0-1.193,1.038-1.852,2.041-2.488,1.422-.9,2.271-1.533,1.783-2.982a3.244,3.244,0,0,0-3.05-1.487.774.774,0,1,1,0-1.549,4.693,4.693,0,0,1,4.475,2.426c.009.019.016.038.023.057.952,2.712-1.066,3.993-2.4,4.84-.619.393-1.322.839-1.322,1.181v.978a.774.774,0,0,1-.774.774Z",
    transform: "translate(-11.241 -5.692)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu13);
export default __webpack_public_path__ + "static/media/menu-13.09a77473e9df29ffc81fdb5475e9a4bc.svg";
export { ForwardRef as ReactComponent };